const e=(e,l)=>l?e.filter((e=>void 0!==l[e.label])):e;export{e as getFilteredOptionsFromCache};
